import { FAQListCombinedProps } from './types';

const usePresenter = (props: FAQListCombinedProps): FAQListCombinedProps => {
  return props;
};

export default usePresenter;
